import { render, staticRenderFns } from "./manual_column_name.vue?vue&type=template&id=4cbe5b4b&"
import script from "./manual_column_name.vue?vue&type=script&lang=js&"
export * from "./manual_column_name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports